<template>
    <div>
        <v-toolbar class="toolbar-element" light absolute flat height="90em">
            <v-toolbar-title class="toolbar-title">Nuevo Reporte Mensual de Salarios</v-toolbar-title>
        </v-toolbar>
        <div class="spacing-top">
            <v-card>
                <v-alert :value="customErrorPresent" type="error">{{ customErrorMessage }}</v-alert>
                <v-card-text>
                    <form>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field v-model="title" :error-messages="titleErrors" label="Título"
                                              required @input="$v.title.$touch()" :readonly="saving"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="period" return-masked-value mask="####-##" label="Período"
                                              placeholder="YYYY-MM" :errorMessages="periodErrors" @input="$v.period.$touch()"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-textarea v-model="message" :error-messages="messageErrors" label="Observaciones"
                                    required @input="$v.message.$touch()" :readonly="saving"></v-textarea>
                        <v-layout row wrap>
                            <v-flex xs6 pr-2>
                                <SelectItems v-model="personas" :items="personasNames" itemText="nombre" itemValue="id"
                                             label="Grupos de personas" :loading="loadingCriterion"></SelectItems>
                            </v-flex>
                            <v-flex xs6 pl-2>
                                <v-autocomplete v-model="club" :items="clubesNames" itemText="nombre" itemValue="pk" chips
                                                label="Club" :loading="loadingClubs" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <EmailCombobox ref="emails"></EmailCombobox>
                            </v-flex>
                        </v-layout>
                        <AttachFile ref="fileInput" @upload="uploadFiles" description></AttachFile>
                        <div v-if="saving">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                            <v-subheader class="right">Cargando, por favor espere.</v-subheader>
                        </div>
                        <v-btn @click="openFileDirectory" color="primary" :disabled="saving">Agregar adjuntos</v-btn>
                        <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Crear</v-btn>
                    </form>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import { recipientsMixin } from '../../../mixins/recipientsMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import { settlementsMixin } from '../../../mixins/settlementsMixin'

import EmailCombobox from '../../../common/ui/EmailCombobox'
import SelectItems from '../../../common/ui/SelectItems'
import AttachFile from '../../../common/ui/AttachFile'

const MIN_LENGTH_PERIOD = 7

export default {
  mixins: [validationMixin, s3UploadMixin, recipientsMixin, settlementsMixin],

  validations () {
    return {
      title: { required },
      message: { required },
      period: {
        required: true,
        minLength: minLength(MIN_LENGTH_PERIOD)
      }
    }
  },

  components: {
    AttachFile,
    SelectItems,
    EmailCombobox
  },

  data: () => ({
    apiPath: '/settlementplayer/new',
    routerPath: 'liquidacionesJugadores'
  }),

  methods: {
    getPayload () {
      return {
        'title': this.title,
        'period': this.period,
        'description': this.message,
        'assets': this.assets,
        'clubes': (this.club) ? [this.club] : [],
        'person_criteria': this.personas,
        'grupos': this.grupos,
        'emails': this.$refs.emails.getEmails()
      }
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    }
  },

  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
    .spacing-top {
        margin-top: 6em !important;
    }
    .toolbar-title {
        font-size: 2.2em;
        font-family: SourceSansProLight, sans-serif;
        color: #293968;
    }
    .toolbar-element {
        background: linear-gradient(#e2e2e2, #cbd1db);
    }
</style>
